import React, {useState, useRef} from 'react'
import Slider, {Settings} from 'react-slick'
import cn from 'classnames'

import {ProductDetails_product_images} from './_gql-types/ProductDetails'

import styles from './ProductImageGallery.module.scss'

interface Props {
  width?: number
  images?: (ProductDetails_product_images | null)[] | null

}

export default function ProductImageGallery({width, images}: Props) {
  const [selectedImg, setSelectedImg] = useState<number>(0)
  const slider = useRef<Slider>(null)
  const miniSlider = useRef<Slider>(null)
  const miniIsVertical = width && width >= 1200

  const mainSettings: Settings = {
    dots: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    swipeToSlide: true,
    waitForAnimate: false,
    beforeChange: (_, nextSlide) => setSelectedImg(nextSlide),
  }

  const miniSettings: Settings = {
    dots: false,
    infinite: false,
    slidesToShow: (width && width < 900) ? 3 : 4,
    slidesToScroll: 1,
    autoplay: false,
    swipeToSlide: true,
    waitForAnimate: true,
    vertical: miniIsVertical ? true : false,
    verticalSwiping: miniIsVertical ? true : false,
  }

  return (
    <div className={cn(styles['prod-gallery'], {[styles['prod-gallery--vertical']]: miniIsVertical})}>
      <div className={styles['prod-gallery__main']}>
        <Slider ref={slider} {...mainSettings} asNavFor={miniSlider.current || undefined}>
          {images?.map((image, index) => image?.url && (
            // Yes this div needs to be here, bacause otherwise `style` will be oberwritten by Slider on the child
            <div key={index} className={styles['prod-gallery__main__item']}>
              <div
                role="img"
                aria-label={image.alt}
                style={{ backgroundImage: `url(${image.url})` }}
                className={styles['prod-gallery__main__img']}
              />
            </div>
          ))}
        </Slider>
      </div>
      {!!images && images?.length > 1 && (
        <div className={cn(styles['prod-gallery__minis'], {'vertical': miniIsVertical})}>
          <Slider ref={miniSlider} {...miniSettings}>
            {images?.map((image, index) => image?.url && (
              // Yes this div also needs to be here for spacing reasons
              <div key={index} className={styles['prod-gallery__minis__item-wrapper']}>
                <div
                  className={cn(styles['prod-gallery__minis__item'], {
                    [styles['prod-gallery__minis__item--isActive']]: selectedImg === index,
                  })}
                  onClick={() => {
                    slider?.current?.slickGoTo(index)
                  }}
                >
                  <div
                    role="img"
                    aria-label={image.alt}
                    style={{ backgroundImage: `url(${image.url})` }}
                    className={styles['prod-gallery__minis__item__img']}
                  />
                </div>
              </div>
            ))}
          </Slider>
        </div>
      )}
    </div>
  )
}
